import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SistemaService} from '@servicios/Sistema.Service';
import {AlineacionEnum} from './CheckBox.enum';

declare var $: any;
declare function Focus(id : string) : any;

const noop = () =>
{
};

export const CUSTOM_CHECKBOX_CONTROL_VALUE_ACCESSOR: any =
  {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckBoxComponent),
    multi: true
  };

@Component(
  {
    selector: 'checkBoxCustom',
    templateUrl: './CheckBox.template.html',
    styleUrls: ['./CheckBox.scss'],
    providers: [CUSTOM_CHECKBOX_CONTROL_VALUE_ACCESSOR]
  })

export class CheckBoxComponent implements ControlValueAccessor
{
  public innerValue : string = "";

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  @Input() titulo : string = ""; // titulo del input
  @Input() disabled : boolean = false; // control deshabilitado
  @Input() alineacion : AlineacionEnum = AlineacionEnum.Centrada; // control deshabilitado
  @Input() sinMargen : boolean = false; //indica si el control tiene margen o no

  public id : number = 0;
  public AlineacionEnum = AlineacionEnum;

  constructor(public sistemaService : SistemaService)
  {
    this.sistemaService.numeroControl++;
    this.id = this.sistemaService.numeroControl;
  }

  ngOnInit()
  {
  }

  Focus()
  {
  }

  LimpiarValor()
  {
    this.valor = '';
    Focus("input" + this.id);
  }

  // control ngModel
  get valor(): any
  {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set valor(nuevoValor: any)
  {
    if (nuevoValor !== this.innerValue)
    {
      this.innerValue = nuevoValor;
      this.onChangeCallback(nuevoValor);
    }
  }

  writeValue(valor: any)
  {
    if (valor !== this.innerValue)
    {
      this.innerValue = valor;
    }
  }

  registerOnChange(fn: any)
  {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any)
  {
    this.onTouchedCallback = fn;
  }
  
  TeclaPresionada(tecla : any)
  {
    if(tecla.keyCode ==  13 || tecla.keyCode == 32)
    {
      this.valor = !this.valor;
    }
  }
}
